/**
 * Bring the stored per-audit auditor picks (auditsCreate.auditors) in line with
 * the audits currently selected on steps 1-2 (`rows`).
 *
 * The list used to be written only while it was empty, so going Back after the
 * Auditors step and swapping a location left it stale: the dropped location's
 * entry stayed (and could block CREATE through AuditSummary's auditor gate)
 * while the newly added one had no entry at all (and slipped past the gate).
 *
 * Entries for audits still selected are kept as-is, so picks already made
 * survive. Ids are indexes into auditsCreate.data, so an entry only counts as
 * the same audit if its branch and location still match.
 *
 * Returns null when nothing needs to change, so callers can skip the dispatch.
 */
export default (current = [], rows = []) => {
    const byId = new Map(current.map((item) => [item.id, item]));
    const isSame = (row) => {
        const prev = byId.get(row.id);
        return (
            !!prev &&
            prev.branch === row.branch &&
            prev.location === row.location
        );
    };

    if (current.length === rows.length && rows.every(isSame)) return null;

    return rows.map((row) => (isSame(row) ? byId.get(row.id) : row));
};
